import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { isValidReturnUrl } from '../../../utils/urlUtils';
import { getRedirectUrlWithToken } from '../../../utils/productAccessRedirect';

/**
 * Handles redirecting authenticated users to a return URL provided in the query params.
 * This is useful when an external application (like Pathways or Polls) redirects the user
 * to the portal for authentication, and wants them redirected back after login.
 */
const ReturnUrlHandler = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  const hasAttemptedRedirect = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || isLoading || !returnTo || hasAttemptedRedirect.current) return;

    if (!isValidReturnUrl(returnTo)) {
      console.warn('Invalid returnTo URL ignored:', returnTo);
      return;
    }

    hasAttemptedRedirect.current = true;

    getRedirectUrlWithToken(returnTo, user?.products).then((destination) => {
      if (destination) {
        window.location.href = destination;
      } else {
        console.error('Failed to get access token for returnTo:', returnTo);
      }
    });
  }, [isAuthenticated, isLoading, returnTo, user]);

  return null;
};

export default ReturnUrlHandler;
